import { getPath } from '@/router/common'

const baseUrl = {
  title: '仲裁管理',
  path: 'Arbitration'
}

export default [
  {
    path: getPath('ArbitrationManage', baseUrl),
    name: 'ArbitrationManage',
    component: () => import(/* webpackChunkName: "ArbitrationManage" */ '@/views/qualityManage/arbitration/arbitrationManage/index.vue'),
    meta: {
      title: '仲裁管理'
    }
  },
  {
    path: getPath('ArbitrationHandle', baseUrl),
    name: 'ArbitrationHandle',
    component: () => import(/* webpackChunkName: "ArbitrationHandle" */ '@/views/qualityManage/arbitration/arbitrationHandle/index.vue'),
    meta: {
      title: '仲裁处理'
    }
  }
]
